export const createFlightSegmentInfo = ({
  airlineName = '',
  flightNumber = '',
  cabinClass = ''
} = {}) => {
  const combinedFlightNumber = flightNumber ? `(${flightNumber})` : '';
  const firstFinalSeperator = airlineName && combinedFlightNumber ? ' ' : '';
  const secondFinalSeperator = cabinClass && (airlineName || combinedFlightNumber) ? ', ' : '';
  return `${airlineName}${firstFinalSeperator}${combinedFlightNumber}${secondFinalSeperator}${cabinClass}`;
};